/** Possible types for a Move entity. */
export enum MOVE_TYPES {
  SIMPLE_ENTRY = 'SIMPLE_ENTRY',
  SIMPLE_OUTPUT = 'SIMPLE_OUTPUT',
  TRANSFER = 'TRANSFER',
  TAKEOUT = 'TAKEOUT',
  SALE_OUT = 'SALE_OUT',
  RETURN = 'RETURN',
  SALE_ORDER = 'SALE_ORDER',
}

/** Possible states for a Move entity. */
export enum MOVE_STATES {
  COMPLETED = 'COMPLETED',
  INCOMPLETE = 'INCOMPLETE',
  DRAFT = 'DRAFT',
  PROCESSING = 'PROCESSING',
  PENDING = 'PENDING',
  INVALID = 'INVALID',
  UNASSIGNED = 'UNASSIGNED',
  CLOSED = 'CLOSED',
}
